/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type Luci_Shopping_Api_Models_TenantDomain = {
  id?: number;
  domainType?: Luci_Shopping_Api_Models_TenantDomain.domainType;
  domain?: string;
};
export namespace Luci_Shopping_Api_Models_TenantDomain {
  export enum domainType {
    SHOPPING_PORTAL = 'ShoppingPortal',
    INVOICE_PORTAL = 'InvoicePortal',
    MANAGEMENT_PORTAL = 'ManagementPortal',
  }
}

